var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-bg-color",style:(_vm.styles)},[_c('ion-icon',{attrs:{"name":_vm.data.icon}}),_vm._v(" "),_c('div',[_vm._v("\n    "+_vm._s(_vm.data.text)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38762604","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/views/components/status.vue
// module id = 879
// module chunks = 0